import { IconButton } from '@mui/material';

import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { Strings } from '@app/constants';
import { IAddProjectSchema } from '../types';
import { useDialog } from '@app/hooks';
import AddProject from './add-project';

interface Props {
  row: IAddProjectSchema;
}

const RowActions = ({ row }: Props) => {
  const menuPopover = useMenuPopover();
  const editDialog = useDialog();

  const actions = [{ label: Strings.rowActions.edit, callback: editDialog.show }];

  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
      {editDialog.visible && <AddProject open onClose={editDialog.hide} row={row} />}
    </>
  );
};

export { RowActions };
